import axiosInstance from "../axiosConfig";

import { logger } from "utils/logger";
export const updateTemplateSchemaValue = async (
  versionId: number | null,
  templateId: number,
  schemaData: Record<string, string | number>
): Promise<{ success: boolean; version_id?: number; errors?: string[] }> => {
  const url = `/documents/update-template-schema-value/`;

  const data = {
    version_id: versionId,
    template_id: templateId,
    schema_data: schemaData,
  };

  try {
    const response = await axiosInstance.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; 
  } catch (error) {
    logger.error("Ошибка при обновлении значений схемы:", error);
    throw error;
  }
};



export const getTemplateSchemaValues = async (
  versionId: number
): Promise<Record<string, string | null>> => {
  const url = `/documents/get-template-schema-values/`;

  try {
    const response = await axiosInstance.post(url, { version_id: versionId }, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data.data || {}; // Возвращаем `data`, в котором `{ schema_id: value }`
  } catch (error) {
    logger.error("Ошибка при получении значений схем:", error);
    throw error;
  }
};

